import { addMonths, endOfDay, isAfter, isBefore } from "date-fns";
import { RestaurantSetting } from "./RestaurantSetting";

export type paymentInterval = "YEARLY" | "QUARTERLY" | "HALF_YEARLY" | "MONTHLY";

export interface RestaurantSubscription {
    id: number;
    restaurantShortName: string;
    subscriptionPlanId: string;
    subscriptionStartedAt: string; // ISO date string
    validTo: string; // ISO date string
    nextDueDate?: string;
    paymentInterval: paymentInterval;
    features: string[];
    status: "ACTIVE" | "CANCELLED";
    cancellationReason?: 'UPGRADED' | 'CANCELED_BY_USER' | 'CANCELED_BY_SYSTEM' | 'PAYMENT_FAILED';
}

export type subscriptionPlan = "FREE" | "STANDARD" | "PRO";

export function getCurrentSubscription(restaurantSetting: RestaurantSetting) {
    const now = new Date();
    return restaurantSetting.subscriptions.find(subscription => {
        return isAfter(now, subscription.subscriptionStartedAt) && isBefore(now, endOfDay(subscription.validTo));
    });
}

export function getCurrentSubscriptionPlan(restaurantSetting: RestaurantSetting): subscriptionPlan {
    const currentSubscription = getCurrentSubscription(restaurantSetting);
    if (currentSubscription == null) return "FREE";
    return currentSubscription.subscriptionPlanId as subscriptionPlan;
}

export function getCurrentFeatures(restaurantSetting: RestaurantSetting) {
    const currentSubscription = getCurrentSubscription(restaurantSetting);
    if (currentSubscription == null) return [];
    return currentSubscription.features;
}


export function getNextDueDate(interval: paymentInterval, date: Date) {
    switch (interval) {
        case "MONTHLY":
            return addMonths(date, 1);
        case "QUARTERLY":
            return addMonths(date, 3);
        case "HALF_YEARLY":
            return addMonths(date, 6);
        case "YEARLY":
            return addMonths(date, 12);
    }
}